import { axios } from '../../utils/apiUtils';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getAxiosConfig } from '../../utils/apiUtils';
import Season from '../../components/season';
import commonStyles from '../../common';
import { Col, Container, ListGroup, Modal, Row } from 'react-bootstrap';

import seasonIcon from '../../assets/images/stations.svg';
import { getOneTimeEvents, isAllowedToPlayVideo, setOneTimeEvents, getLoggedInUser, updateUser } from '../../utils/authUtils';

import { Redirect } from 'react-router';

const styles = {
  welcomeBar: {
    marginLeft: '15px',
    marginRight: '15px',
  },
  header: {
    backgroundColor: '#f0f2f5',
    marginTop: '32px',
    marginBottom: '32px',
  },
  title: {
    ...commonStyles.chungungoH1,
    color: 'darkOrange',
  },
  container: {
    paddingRight: 0,
    paddingLeft: 0,
  },
  row: {
    marginLeft: 0,
    marginRight: 0,
  }
};

const Explore = (props) => {
  const { t, i18n } = useTranslation();
  const [seasons, setSeasons] = useState([]);
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [monthly, setMonthly] = useState([]);
  const [newestSeasons, setNewestSeasons] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [keepWatching, setKeepWatching] = useState([]); 
  const [visitAgain, setVisitAgain] = useState([]);

  const currentUser = getLoggedInUser();
  const [user, setUser] = useState(); 

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  const refreshUserData = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/users/${getLoggedInUser().user.id}`,
      getAxiosConfig(),
    )
      .then((userResponse) => {
        setUser(userResponse.data);
        updateUser({
          user: userResponse.data
        });
        refreshKeepWatchingList();
        refreshVisitAgainList();
      })
      .catch((userError) => {
        console.debug(userError);
      });
  };

  const refreshExperiencesList = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/experiences/all`,
      {
        ...getAxiosConfig(),
      },
    )
      .then((experiencesResponse) => {
        setExperiences(experiencesResponse.data);
      })
      .catch(console.error);
  };

  const refreshSeasonsList = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/seasons/complete_list`,
      {
        ...getAxiosConfig(),
      },
    )
      .then((seasonsResponse) => {
        setSeasons(seasonsResponse.data);
      })
      .catch(console.error);
  };

    // get most watched seasons
    const refreshMonthlyData = () => {
      axios.get(
        `${process.env.REACT_APP_API_URL}/analytics/completed_experiences`,
        getAxiosConfig(),
        ).then((monthlyResponse) => {
          setMonthly(monthlyResponse.data);
        })
        .catch((userError) => {
          console.debug(userError);
        });
    };
  
    // get new seasons
    const refreshNewestSeasonsList = () => {
      axios.get(
        `${process.env.REACT_APP_API_URL}/seasons/newest_seasons_list`,
        {
          ...getAxiosConfig(),
        },
      )
        .then((newestSeasonsResponse) => {
          setNewestSeasons(newestSeasonsResponse.data);
        })
        .catch(console.error);
    };
    // get keep watching seasons
    const refreshKeepWatchingList = () => {
      axios.get(
        `${process.env.REACT_APP_API_URL}/seasons/${user.id}/keep_watching`,
        {
          ...getAxiosConfig(),
        },
      )
        .then((keepWatchingResponse) => {
          setKeepWatching(keepWatchingResponse.data);
        })
        .catch(console.error);
    };

    // get visit again seasons
    const refreshVisitAgainList = () => {
      axios.get(
        `${process.env.REACT_APP_API_URL}/seasons/${user.id}/visit_again`,
        {
          ...getAxiosConfig(),
        },
      )
        .then((visitAgainResponse) => {
          setVisitAgain(visitAgainResponse.data);
        })
        .catch(console.error);
    };

  useEffect(
    () => {
      refreshSeasonsList();
      refreshExperiencesList();
      refreshUserData();

      refreshMonthlyData();
      refreshNewestSeasonsList();
    },
    []
  );

  const filterSeasons = [];

  if (props.filterBy == 'featured') {
    seasons.map((season) => season.isFeatured && filterSeasons.push(season))  
  }

  if (props.filterBy == 'new') {
    newestSeasons.map((season) => filterSeasons.push(season))
    }

  if (props.filterBy == 'continue') {
    keepWatching.map((season) => filterSeasons.push(season))
  }

  if (props.filterBy == 'visitagain') {
    visitAgain.map((season) => filterSeasons.push(season))
  }

  if (props.filterBy == 'all') {
    seasons.map((season) => filterSeasons.push(season))
  }

  if (props.filterBy == 'mostwatched') {
    monthly.map((season) => filterSeasons.push(season))
  }

  return (
    <section class="pt-4 mb-5 col-12">
      <div class="container"
        style={styles.container}
      >
        <div class="row pt-5" style={styles.row}>
          <div class="breadcrumb1 col-12 px-0">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb p-0">
                <li class="breadcrumb-item"><a href="/seasons">HOME</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  {t(`explore.${props.filterBy}`).toUpperCase()}
                </li>
              </ol>
            </nav>
          </div>
          <div class="col-12 align-self-start caj-Titulo-Principal pt-3 px-0">
            <span 
              class="icon-headline-1 station-icon"
              style={{
                backgroundImage: `url(${seasonIcon})`
              }}
            ></span>
            <h1 class="headline-1"> {t(`explore.${props.filterBy}`).toUpperCase()}</h1>
          </div>
            <div className="row w-100">

              {filterSeasons.map((season) => (
                <div className="col-4">
                <Season season={season} />
                </div>
              ))}
            </div>
        </div>
      </div>
    </section>
  );
};

export default Explore;